module.exports = __webpack_public_path__ + "static/seller/img/ws.d42cc4ab.png";